import React from "react";
import CommonDrawer from "components/Design/Drawer/Drawer";
import { useTranslation, Link, useI18next } from "gatsby-plugin-react-i18next";
import NavOpenHeader from "./NavOpenHeader";
import ButtonFullWidthWithIcon from "components/Design/Button/ButtonFullWidthWithIcon";
import RoomSelectionSearchDrawer from "components/Design/Drawer/RoomSelectionSearchDrawer";
import ConditionalLink from "components/ConditionalLink";
import { embedLanguageInUrl } from "utils/embedLanguageInUrl";
import { AYANA_LINK } from "store/constants/link";
import Icon from "components/CommonIcon/Icon";
import {
  ROCKBAR_RESTAURANT,
  JAKARTA_LOCATION,
} from "store/constants/hotel";
import { WECHAT_LINK } from "store/constants/link";
import { AYANA_JAKARTA_WHATSAPP_LINK } from "store/constants/socmedLink";
import "./style.less";

const BackButton = () => {
  const { t } = useTranslation("homepage");
  const { language } = useI18next();

  return (
    <ConditionalLink link={embedLanguageInUrl(AYANA_LINK, language)}>
      <div className="flex items-center">
        <Icon name="left-arrow" fontSize="text-16" />
        <p className="uppercase text-11 leading-18 text-gold tracking-16 font-mulish block ml-8 font-semibold">
          {t("back to")}
        </p>
      </div>
    </ConditionalLink>
  );
};

const NavBarMobileOpen = ({
  visible,
  destinationCards,
  moreItems,
  menuList,
  close,
  bookingEngineLink,
  cartCount,
  contactOnDesktop,
  logo,
  logoLink,
  whatsappContact,
  restaurant,
  location,
  destination,
  hotelCode,
  minimumStay,
  bookingCode,
  whatsappLink,
  stayPeriod,
  isPackage,
  hotel,
  packageCode,
  hotelId,
  roomId,
  minLeadDay,
}) => {
  const { language } = useI18next();
  const { t } = useTranslation("homepage");

  let contactLink = whatsappLink;

  if (location === JAKARTA_LOCATION) {
    contactLink = AYANA_JAKARTA_WHATSAPP_LINK;
  }

  if (language === "zh") {
    contactLink = WECHAT_LINK;
  }

  let iconName;
  let iconClassName;
  if (location === JAKARTA_LOCATION) {
    iconName = null;
    iconClassName = "text-green-wa-dark";
  } else {
    iconName = language === "zh" ? "weibo" : "whatsapp";
    iconClassName = language === "zh" ? "" : "text-green";
  }

  return (
    <CommonDrawer placement="top" visible={visible} className="navbar-drawer">
      <NavOpenHeader
        onClose={close}
        bookingEngineLink={bookingEngineLink}
        cartCount={cartCount}
        hotel={hotel}
      />
      <div className="px-20 py-24">
        <BackButton />
        <div className="my-20">
          <ConditionalLink sameTab={true} link={logoLink}>
            {logo}
          </ConditionalLink>
        </div>
        {menuList}
        <div className="mt-30">
          <p className="text-11 uppercase font-semibold font-mulish mb-16 leading-18 tracking-16 text-gold">
            {t("other Ayana destinations")}
          </p>
          <div className="space-y-20">{destinationCards}</div>
        </div>
        <div className="mt-30 mb-80 font-mulish text-12-22 capitalize space-y-16">
          {moreItems}
        </div>
      </div>
      <div>
        {contactOnDesktop ? (
          <div className="fixed bottom-0 w-full z-10">
            <ButtonFullWidthWithIcon
              label={contactOnDesktop?.label || t("Contact Us")}
              iconName={iconName}
              iconClassName={iconClassName}
              iconLink={contactLink}
              buttonLink={contactOnDesktop?.url}
            />
          </div>
        ) : (
          <RoomSelectionSearchDrawer
            stayPeriod={stayPeriod}
            minimumStay={minimumStay}
            bookingCode={bookingCode}
            hotelCode={hotelCode}
            location={location}
            destination={destination}
            isPackage={isPackage}
            packageCode={packageCode}
            cta={(onClick) => (
              <div className="fixed bottom-0 w-full z-10">
                <ButtonFullWidthWithIcon
                  label={
                    restaurant === ROCKBAR_RESTAURANT
                      ? t("Book a table")
                      : t("View Rates")
                  }
                  buttonLink={restaurant === ROCKBAR_RESTAURANT && contactLink}
                  onClick={restaurant !== ROCKBAR_RESTAURANT && onClick}
                  iconName={iconName}
                  iconClassName={iconClassName}
                  iconLink={contactLink}
                />
              </div>
            )}
            roomId={roomId}
            hotelId={hotelId}
            minLeadDay={minLeadDay}
          />
        )}
      </div>
    </CommonDrawer>
  );
};

export default NavBarMobileOpen;
